import React from 'react';
import { MdCode, MdDesktopMac, MdLaptopChromebook } from 'react-icons/md';
import styled from 'styled-components';
import SectionTitle from './SectionTitle';
import ServicesSectionItem from './ServicesSectionItem';

const ServicesItemStyles = styled.div`
  padding: 10rem 0;
  .container{

  }
  .services__allItems{
      display: flex;
      gap: 10rem;
      justify-content: space-between
      margin-top: 5rem;
  }
  @media only screen and (max-width: 768px){
      .services__allItems{
          flex-direction: column;
          max-width: 350px;
          margin: 0 auto;
          margin-top: 5rem;
          gap: 5rem;
      }
  }
`;

export default function ServiceSection() {
  return (
    <ServicesItemStyles>
      <div className="container">
        <SectionTitle heading="Services" subheading="what I will do for you" />

        <div className="services__allItems">
          <ServicesSectionItem
            icon={<MdLaptopChromebook />}
            title="Learn"
            description="I am always a learner, learning new things and skills and implementing them."
          />
          <ServicesSectionItem
            icon={<MdCode />}
            title="Code"
            description="Always code, automate boring stuff and convert learnt skills into code, just like vomiting"
          />
          <ServicesSectionItem
            icon={<MdDesktopMac />}
            title="Dev"
            description="I also develop backend web apps with blazing fast with high performance."
          />
        </div>
      </div>
    </ServicesItemStyles>
  );
}
